import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image, View } from 'react-native';
import { TopBar } from '../support-screen/topBar.js'
import * as RootNavigation from '../../../root.navigation.js';


const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;


const PlusIcon = (props) => (
  <Icon {...props} name='plus-square-outline' />
);
const InfoIcon = (props) => (
  <Icon {...props} name='info-outline' />
);
export const NewAddressList = () => {


  return (
    <ScrollView>
      <Layout style={styles.container} level='2' >
        <Layout>
          <TopBar title='ثبت آدرس مشتری' />
        </Layout>
        <Image source= {require('../../../assets/new_invoice.png')} style={{width:width*0.7, height:width*0.7, marginVertical:25}} />
        <Text appearance='hint' style={{margin:40, textAlign:'center', lineHeight:25}}>تکنسین محترم، می توانید از این بخش نسبت به ثبت اطلاعات مشتری و ایجاد کار جدید اقدام نمایید.</Text>
        <View>
        <Button
          style={{borderRadius:10,marginTop:5, paddingVertical:10, width:width*0.85}}
          accessoryLeft={PlusIcon}
          onPress={()=>{RootNavigation.navigate('NewAddress')}}
          >ثبت آدرس جدید</Button>
          <Button
            style={{borderRadius:10,marginTop:5, paddingVertical:10, width:width*0.85}}
            accessoryLeft={InfoIcon}
            appearance='outline'
            onPress={()=>{RootNavigation.navigate('Prices')}}
            >استعلام قیمت</Button>
            </View>
      </Layout>
      </ScrollView>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',
    paddingBottom:25,
    height: height-30


  },
});
